import { styled } from 'styled-components';

import { api } from 'common';

import { Col, Row } from 'react-bootstrap';

import { Pill } from '@vivaahealth/design-system';

interface Props {
  profile?: api.ProviderProfile.Profile | null;
  agesServed?: api.ProviderOrganizationPreference.AgesServed[];
}

const Profile: React.FC<Props> = ({ profile, agesServed }) => {
  return (
    <ProfileDetails className="px-2">
      <StyledCol xs="auto">
        {!!profile?.spokenLanguages?.length && (
          <Pill>
            {profile.spokenLanguages
              .map(
                (lang) =>
                  api.Language.languageMap[
                    lang as api.Language.LanguageWithOther
                  ],
              )
              .join(', ')}
          </Pill>
        )}
      </StyledCol>
      <StyledCol xs="auto">
        {!!profile?.pronouns && <Pill>{profile.pronouns}</Pill>}
      </StyledCol>
      <StyledCol xs="auto" className="px-0">
        {!!agesServed?.length &&
          (agesServed.includes(
            api.ProviderOrganizationPreference.AgesServed.AllAges,
          ) ? (
            <Pill>Serving all ages</Pill>
          ) : (
            <Pill>Serving ages {agesServed.join(', ')}</Pill>
          ))}
      </StyledCol>
    </ProfileDetails>
  );
};

export default Profile;

const ProfileDetails = styled(Row)`
  gap: 4px;
`;

const StyledCol = styled(Col)`
  display: flex;
  gap: 4px;
  padding: 0;
`;
